import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SEO_DATA = {
  "/": {
    title: "GG Fitness | Best Personal Trainer in Bolpur Santiniketan - Gora Ganguly",
    description: "Transform your body with Gora Ganguly, certified fitness coach with 18+ years experience in Bolpur, Santiniketan. Personal training, yoga, karate, nutrition. Free consultation!",
  },
  "/about": {
    title: "About Gora Ganguly | K11 Certified Fitness Coach - Bolpur Santiniketan",
    description: "Meet Gora Ganguly - Exercise Science Expert from K11 Academy, REPS India Registered, Karate Black Belt from Kyokushin-kan Japan. 18+ years transforming lives in Bolpur, Santiniketan.",
  },
  "/qualifications": {
    title: "Qualifications & Certifications | Gora Ganguly - GG Fitness Bolpur",
    description: "K11 Exercise Science Expert, REPS India Registered, AYUSH Yoga Certified, Kyokushin-kan Karate Black Belt, Australian Lifesaving CPR/AED. View all certifications.",
  },
  "/personal-training": {
    title: "Personal Training Services | Weight Training, Crossfit, Yoga - GG Fitness Bolpur",
    description: "Expert personal training in Bolpur Santiniketan: weight training, crossfit, sports conditioning, cardio, aerobics dance, karate, yoga. Customized programs for all fitness levels.",
  },
  "/nutrition": {
    title: "Nutrition Consultation | Diet Planning & Meal Plans - GG Fitness Bolpur",
    description: "Science-based nutrition planning by Gora Ganguly. Customized meal plans, macro optimization, supplement guidance. Personalized diet plans for weight loss, muscle gain & performance.",
  },
  "/online-training": {
    title: "Online Fitness Training | Train From Anywhere in India - GG Fitness",
    description: "Get world-class personal training online from Gora Ganguly. Live video sessions, custom workout plans, nutrition included. Train from anywhere in India with weekly progress reviews.",
  },
  "/reviews": {
    title: "Client Reviews & Testimonials | GG Fitness Bolpur Santiniketan",
    description: "Read real reviews from clients of Gora Ganguly at GG Fitness Bolpur. See what people say about their fitness transformation experience.",
  },
  "/transformations": {
    title: "Client Transformations | Before & After Results - GG Fitness Bolpur",
    description: "Real before & after transformation results from GG Fitness clients. See the incredible body transformations achieved through personalized training and nutrition in Bolpur.",
  },
  "/faq": {
    title: "Fitness FAQ | Common Questions Answered - GG Fitness Bolpur Santiniketan",
    description: "Get answers to common fitness questions: Is weight training safe for seniors? Will lifting make women bulky? Spot reduction myths & more. Expert answers from Gora Ganguly.",
  },
  "/contact": {
    title: "Contact GG Fitness | Book Free Consultation - Bolpur Santiniketan 731204",
    description: "Contact Gora Ganguly at GG Fitness, Bolpur Santiniketan 731204. Call +91 91530 20904 or WhatsApp for a free fitness consultation. Start your transformation today!",
  },
  "/shop": {
    title: "Fitness Shop | Supplements & Gear - GG Fitness Bolpur",
    description: "Shop fitness supplements, gear and accessories from GG Fitness Bolpur. Order via WhatsApp for quick delivery in Santiniketan area.",
  },
};

export function useSEO() {
  const { pathname } = useLocation();

  useEffect(() => {
    const seo = SEO_DATA[pathname];
    if (seo) {
      document.title = seo.title;
      const metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) metaDesc.setAttribute("content", seo.description);

      const ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle) ogTitle.setAttribute("content", seo.title);

      const ogDesc = document.querySelector('meta[property="og:description"]');
      if (ogDesc) ogDesc.setAttribute("content", seo.description);

      const twTitle = document.querySelector('meta[name="twitter:title"]');
      if (twTitle) twTitle.setAttribute("content", seo.title);

      const twDesc = document.querySelector('meta[name="twitter:description"]');
      if (twDesc) twDesc.setAttribute("content", seo.description);
    }
  }, [pathname]);
}
